import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import axios from "axios";
import React from "react";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { toast, ToastContainer } from "react-toastify";
import CustomDataGrid from "../../../components/CustomDataGrid/CustomDataGrid.tsx";
import searchIcon from "./../../../../assets/icons/search.ico";
import Cancel from "./../../../../assets/icons/close.png";
import ViewAll from "./../../../../assets/icons/document.png";
import bin from "./../../../../assets/icons/reject.png";
import edit from "./../../../../assets/icons/edit.png";
import linkactiveImg from "./../../../../assets/images/linkActive.png";
import linkDeactiveImg from "./../../../../assets/images/linkDective.png";
import approveImg from "./../../../../assets/icons/checked.png";
import LoadingView from "../../../components/LoadingView/LoadingView";
import { useMemo } from "react";
import CancelationReasonBankDetailsDialog from "./CancelationReasonDialog/CancelationReasonBankDetailsDialog.tsx";

const WidthdrawDetails = () => {
  const apiAddress = process.env.REACT_APP_SECRET;
  const [dataRows, setDataRows] = React.useState([]);
  const [selectedData, setSelectedData] = React.useState([]);
  const [enableOptions, setEnableOptions] = React.useState(false);
  const [autoCompleteValue, setAutoCompleteValue] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [clickedRestaurant, setClickedRestaurant] = React.useState("");
  const [openCancelReasonDialog, setopenCancelReasonDialog] =
    React.useState(false);
  const [clickedRestaurantDetails, setClickedRestaurantDetails] =
    React.useState([]);
  const [allRestaurantDetails, setAllRestaurantDetails] = React.useState([]);
  const [loading, setloading] = React.useState(false);
  const [dataLoaded, setdataLoaded] = React.useState(false);
  const [openBankDetailsDialouge, setOpenBankDetailsDialouge] = React.useState(false);
  const [multipleBankAccountDetails, setMutipleBankAccountDetails] = React.useState([]);

  const columnsdatas = [
    {
      field: "restaurantName",
      headerName: "Restaurant Name",
      align: "center",
      renderCell: (params) => (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ gap: "5px" }}
        >
          <span>
            {params.value}
          </span>
        </div>
      ),
      headerAlign: "center",
      flex: 2,
    },
    {
      field: "accountHolderName",
      headerName: "Account Holder Name",
      align: "center",
      headerAlign: "center",
      flex: 2,
      renderCell: useMemo(
        () => (params) => {
          return (
            <div
              style={{ cursor: 'pointer' }}
              onClick={() => AccountHolderOnClick(params)}
            >
              <span style={{ cursor: 'pointer', textDecoration: 'underline' }}>
                {params.value.slice(0, 10)}
              </span>
              <img
                style={{ width: '15px', height: '15px', marginLeft: '10px' }}
                src={ViewAll}
              />
            </div>
          );
        },
        []
      ),
    },
    {
      field: "accountNumber",
      headerName: "Account Number",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "sortCode",
      headerName: "Sort Code",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "iban",
      headerName: "IBAN",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "amount",
      headerName: "Amount",
      align: "center",
      headerAlign: "center",
      flex: 1,
    }, 
    {
      field: "createdByUserName",
      headerName: "Requested By",
      align: "center",
      headerAlign: "center",
      flex: 2,
    },
    {
      field: "creationDate",
      headerName: "Request Date",
      align: "center",
      headerAlign: "center",
      flex: 2.5,
      valueFormatter: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        return date.toLocaleString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "2-digit",
          hour12: true
        });
      }
    }    
    ,
    {
      field: "status",
      headerName: "Status",
      renderCell: useMemo(
        () => (params) => {
          return (
            <div
              className={`${params.value == "Approved"
                ? "approve"
                : params.value == "f07294b7-c94d-4d5e-a064-b1282d5b543b" ||
                  params.value == "Pending"
                  ? "pending"
                  : "reject"
                } RoundedStatus`}
            >
              {params.value == "Approved" ? "Approved"
                : params.value == "Pending" ? "Pending"
                  : params.value == "Rejected"
                    ? "Rejected"
                    : "Reject"
              }
            </div>
          );
        },
        []
      ),
      align: "center",
      headerAlign: "center",
      flex: 2.5,
    },
  ];

  const getselectedData = (props) => {
    var temp = props;

    setSelectedData(temp);
    if (props.length > 0) {
      setEnableOptions(true);
    } else {
      setEnableOptions(false);
    }
  };

  const typrOfMenuDatas = [
    { id: 1, title: "Online" },
    { id: 2, title: "In-store" },
    // { id: 3, title: 'Cor' },
    // { id: 3, title: 'Add Type' },
  ];

  const addValue = (props) => {
    setAutoCompleteValue(props);
  };

  const handleClickOpen = (props) => {
    setOpen(true);
    var data = dataRows.find((x) => x.companyLegalName === props);
    console.log("data: " + data.companyLegalName);
    setClickedRestaurant(data);
  };

  const handleAddItem = (AddItemData) => {
    setOpen(AddItemData);
    loadData();
  };

  const handleClickopenCancelReasonDialog = () => {
    setopenCancelReasonDialog(true);
    var tempData = [];
    var allTempData = [];
    selectedData.map((data, index) => {
      var dt = dataRows.find((x) => x.id === data);
      var obj = {
        id: dt.id,
        title: dt.companyLegalName,
      };
      tempData.push(obj);
    });

    dataRows.map((dt, index) => {
      var obj = {
        id: dt.id,
        title: dt.companyLegalName,
      };
      allTempData.push(obj);
    });
    setAllRestaurantDetails(allTempData);
    console.log("tempData: " + tempData[0].title);
    setClickedRestaurantDetails(tempData);
  };

  const handleAddopenCancelReasonDialog = (AddItemData) => {
    setopenCancelReasonDialog(AddItemData);
    loadData();
  };

  React.useEffect(() => {
    loadData();
  }, []);

  const approvedData = async (props) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h1>Are you sure?</h1>
            <p>You want to approve this?</p>
            <button onClick={onClose} className="btn-no btn-common">
              No
            </button>
            <button
              className="btn-yes btn-common"
              onClick={() => {
                // this.handleClickDelete();
                approve(props);
                onClose();
              }}
            >
              Yes
            </button>
          </div>
        );
      },
    });
  };

  const activeLinkData = async (props, text) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h1>Are you sure?</h1>
            <p>{text}</p>
            <button onClick={onClose} className="btn-no btn-common">
              No
            </button>
            <button
              className="btn-yes btn-common"
              onClick={() => {
                // this.handleClickDelete();
                approve(props);
                onClose();
              }}
            >
              Yes
            </button>
          </div>
        );
      },
    });
  };

  const approve = async (data) => {
    const token = localStorage.getItem("gotasteadmintoken");

    if (token) {
    } else {
      window.location.href = "/login";
    }
    setloading(true);
    SetloadingModal(true);

    await axios({
      method: "put",
      url:
        apiAddress +
        "/api/RestaurantBankDetails/updateWithdrawRequestStatusByMultipleIds",
      data: selectedData,
    })
      .then(function (response) {
        setloading(false);
        SetloadingModal(false);
        console.log(response);
        toast.success("Successfully Approved this request", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        loadData();
        setSelectedData([]);
        setEnableOptions(false);
      })
      .catch(function (error) {
        setloading(false);
        SetloadingModal(false);
        console.log(error);
        toast.error("Error" + error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });

    // SetloadingModal(false);
  };

  const loadData = async () => {
    const token = localStorage.getItem("gotasteadmintoken");

    if (token) {
    } else {
      window.location.href = "/login";
    }
    axios({
      method: "get",
      url: apiAddress + "/api/RestaurantBankDetails/GetAllWithdrawRequests",
      headers: {
        Authorization: "Bearer " + token,
      },
    })
      .then(function (response) {
        // console.log(response.data);
        setDataRows(response.data);
        var state = false;
        setdataLoaded(state);
      })
      .catch(function (error) { });
  };
  const [loadingModal, SetloadingModal] = React.useState(false);

  const closeLoadingModal = () => {
    SetloadingModal(false);
  };

  const pendingRequests = dataRows?.filter(
    (x) => x?.approvalStatusDescription === "Pending"
  );

  const approvedRequests = dataRows?.filter(
    (x) => x?.approvalStatusDescription === "Approved"
  );

  const linkActivated = dataRows?.filter(
    (x) => x?.approvalStatusDescription === "Link Activated"
  );

  const AccountHolderOnClick = (data) => {
    const token = localStorage.getItem("gotasteadmintoken");

    if (token) {
    } else {
      window.location.href = "/login";
    }
    axios({
      method: "get",
      url: apiAddress + "/api/RestaurantBankDetails/GetMultipleBankDetailsByRestaurantId/" + data.row.restaurantId
    })
      .then(function (response) {
        setMutipleBankAccountDetails(response.data);
      })
      .catch(function (error) { });

    setOpenBankDetailsDialouge(true);
  }

  const handleClose = () => {
    setOpenBankDetailsDialouge(false);
  }

  return (
    <div className="w-100 p-3">
      <LoadingView open={loadingModal} close={closeLoadingModal} />
      <ToastContainer />{" "}
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        mt={2}
        mb={2}
      >
        <Grid item>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <div
                className={` ${enableOptions ? "" : "disable"}  roundedCorner`}
                onClick={() => {
                  approvedData(1);
                }}
              >
                <img src={approveImg} alt="" style={{ width: "1rem" }} />{" "}
                Approve
              </div>
            </Grid>
            <Grid item>
              <div
                className={` ${enableOptions ? "" : "disable"}  roundedCorner`}
                onClick={() => {
                  handleClickopenCancelReasonDialog();
                }}
              >
                <img src={bin} alt="" style={{ width: "1rem" }} /> Reject
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container flexDirection={"column"} alignItems={"center"}>
            <Grid item>
              <img src={searchIcon} alt="" style={{ width: "1rem" }} />
            </Grid>
            <Grid item>Search</Grid>
          </Grid>
        </Grid>
      </Grid>
      {dataRows.length > 0 ? (
        <CustomDataGrid
          columns={columnsdatas}
          dataRows={dataRows}
          getselectedData={getselectedData}
          selectedRows={selectedData}
          isLoading={loading}
        />
      ) : (
        "Nothing found"
      )}
      <CancelationReasonBankDetailsDialog
        open={openCancelReasonDialog}
        onClose={handleAddopenCancelReasonDialog}
        dialogName={"Add On"}
        restaurantName={clickedRestaurantDetails}
        allRestaurant={allRestaurantDetails}
        from={1}
        setSelectedData={setSelectedData}
        setEnableOptions={setEnableOptions}
      />

      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={openBankDetailsDialouge}
        onClose={handleClose}
      >
        <LoadingView open={loadingModal} close={closeLoadingModal} />
        <Grid container className="d-flex align-items-center">
          <Grid item xs={6}>
            <DialogTitle>Available Bank Details</DialogTitle>
          </Grid>
          <Grid item xs={6}>
            <DialogActions>
              <Button onClick={handleClose}>
                <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
              </Button>
            </DialogActions>
          </Grid>
        </Grid>
        <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
          <div style={{ overflow: 'scroll', maxHeight: '350px' }}>
            <table style={{ width: '100%', textAlign: 'center', borderCollapse: 'collapse', fontSize: '14px' }}>
              <thead>
                <tr>
                  <th>Account Holder</th>
                  <th>Account Number</th>
                  <th>Sort Code</th>
                  <th>IBAN</th>
                  <th>Active</th>
                </tr>
              </thead>
              <tbody>
                {multipleBankAccountDetails.slice(0, 5).map((item) => (
                  <tr key={item.id} style={{ fontWeight: 'bold' }}>
                    <td style={{ textAlign: 'center' }}>{item.accountHolderName}</td>
                    <td style={{ textAlign: 'center' }}>{item.accountNumber}</td>
                    <td style={{ textAlign: 'center' }}>{item.sortCode}</td>
                    <td style={{ textAlign: 'center' }}>{item.iban}</td>
                    <td style={{ textAlign: 'center' }}>
                      <div
                        className={`${item.isActive == 1
                          ? "approve"
                          : "pending"
                          } RoundedStatus`}
                      >
                        {item.isActive == 1 ? "Approved"
                          : "Pending"
                        }
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default WidthdrawDetails;
